import '/app/brewery-packages/content/content-editor-plugin-quote/src/Quote.css-raw';
export default {
  "quote": "contacts-cbf4f629-quote-D9SRnq",
  "icon": "contacts-cbf4f629-icon-D9SRnq"
};